function heroHomeSmokeReveal() {
	const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	const picStart = document.querySelector('[data-hero-home="pic-start"]');
	if (!picStart) return;
	const heroHome = picStart.closest(".hero-home");

	if (prefersReduced) {
		picStart.classList.add("is-reveal-done");
		return;
	}

	const imgStart = picStart.querySelector("img");
	if (!imgStart) return;

	const DELAY    = 750;  // ms before smoke begins
	const DURATION = 3600; // ms for the full smoke animation

	// Aligné sur .hero-home__pic img { object-position } (_home.scss)
	const OBJ_POS_X = 0.5;
	const OBJ_POS_Y = 0.94;

	// — Canvas (replaces the img element visually) —
	const canvas = document.createElement("canvas");
	canvas.setAttribute("aria-hidden", "true");
	canvas.style.cssText = "position:absolute;inset:0;width:100%;height:100%;";

	const dpr  = window.devicePixelRatio || 1;
	const rect = picStart.getBoundingClientRect();
	const W    = Math.round(rect.width * dpr);
	const H    = Math.round(rect.height * dpr);

	if (!W || !H) {
		picStart.classList.add("is-reveal-done");
		return;
	}

	canvas.width  = W;
	canvas.height = H;

	picStart.appendChild(canvas);
	imgStart.style.opacity = "0"; // canvas takes over

	const ctx    = canvas.getContext("2d");
	const off    = document.createElement("canvas");
	off.width    = W;
	off.height   = H;
	const offCtx = off.getContext("2d");

	// object-fit: cover + object-position (voir _home.scss sur .hero-home__pic img)
	function drawCover(context, img) {
		const iw = img.naturalWidth || 1;
		const ih = img.naturalHeight || 1;
		const dw = W;
		const dh = H;
		const scale = Math.max(dw / iw, dh / ih);
		const sw = dw / scale;
		const sh = dh / scale;
		let sx = OBJ_POS_X * iw - OBJ_POS_X * sw;
		let sy = OBJ_POS_Y * ih - OBJ_POS_Y * sh;
		sx = Math.max(0, Math.min(sx, iw - sw));
		sy = Math.max(0, Math.min(sy, ih - sh));
		context.drawImage(img, sx, sy, sw, sh, 0, 0, dw, dh);
	}

	// — Smoke puff generation —
	// Each puff is a soft radial circle that "eats" the image via destination-out
	const PUFFS_PER_SIDE = 10;
	const puffs = [];
	let t0;

	function generatePuffs() {
		// 1. Dedicated corner puffs — start at the 4 corners, grow and drift inward
		//    vy drives a slight diagonal movement toward the image center
		[
			{ dir:  1, x0: -W * 0.02, y: H * 0.00, vy:  H * 0.045 / 1000 }, // top-left
			{ dir: -1, x0:  W * 1.02, y: H * 0.00, vy:  H * 0.045 / 1000 }, // top-right
			{ dir:  1, x0: -W * 0.02, y: H * 1.00, vy: -H * 0.045 / 1000 }, // bottom-left
			{ dir: -1, x0:  W * 1.02, y: H * 1.00, vy: -H * 0.045 / 1000 }, // bottom-right
		].forEach(({ dir, x0, y, vy }) => {
			puffs.push({
				dir, x0, y, vy,
				r0:   W * 0.17,
				vr:   W * 0.030 / 1000,
				vx:   W * 0.165 / 1000,
				born: t0 + DELAY,
			});
		});

		// 2. Regular horizontal puffs covering the rest of the height
		for (let i = 0; i < PUFFS_PER_SIDE; i++) {
			const t     = i / (PUFFS_PER_SIDE - 1);
			const yBase = H * (0.07 + t * 0.86); // leave corner areas to corner puffs
			const delay = t0 + DELAY + t * DURATION * 0.55;

			[-1, 1].forEach((dir) => {
				puffs.push({
					dir,
					x0:   dir > 0 ? -W * 0.14 : W * 1.14,
					y:    yBase + H * 0.05 * (Math.random() - 0.5),
					vy:   0,
					r0:   W * (0.10 + Math.random() * 0.07),
					vr:   W * (0.026 + Math.random() * 0.014) / 1000,
					vx:   W * (0.155 + Math.random() * 0.065) / 1000,
					born: delay + Math.random() * 220,
				});
			});
		}
	}

	// — Render loop —
	function frame(now) {
		const elapsed = now - t0;
		const u       = Math.max(0, Math.min(1, (elapsed - DELAY) / DURATION));

		// 1. Draw pic-start onto offscreen canvas
		offCtx.globalCompositeOperation = "source-over";
		offCtx.clearRect(0, 0, W, H);
		if (imgStart.naturalWidth) drawCover(offCtx, imgStart);

		// 2. Punch holes with smoke puffs (destination-out composite)
		offCtx.globalCompositeOperation = "destination-out";

		for (const p of puffs) {
			if (now < p.born) continue;

			const age = now - p.born;
			const x   = p.x0 + p.dir * p.vx * age;
			const y   = p.y  + (p.vy || 0) * age;
			const r   = p.r0 + p.vr * age;
			// Ramp opacity up over 400ms for a gradual appearance
			const opc = Math.min(1, age / 400);

			const g = offCtx.createRadialGradient(x, y, 0, x, y, r);
			g.addColorStop(0,    `rgba(255,255,255,${(opc * 0.82).toFixed(3)})`);
			g.addColorStop(0.28, `rgba(255,255,255,${(opc * 0.68).toFixed(3)})`);
			g.addColorStop(0.55, `rgba(255,255,255,${(opc * 0.40).toFixed(3)})`);
			g.addColorStop(0.78, `rgba(255,255,255,${(opc * 0.14).toFixed(3)})`);
			g.addColorStop(1,    "rgba(255,255,255,0)");

			offCtx.beginPath();
			offCtx.arc(x, y, r, 0, Math.PI * 2);
			offCtx.fillStyle = g;
			offCtx.fill();
		}

		// 3. Blit offscreen onto visible canvas
		ctx.clearRect(0, 0, W, H);
		ctx.drawImage(off, 0, 0);

		// 4. Overall fade-out from 30% progress for complete dissolution
		const fadeU         = Math.max(0, (u - 0.30) / 0.70);
		canvas.style.opacity = (1 - fadeU).toFixed(3);

		// 5. Reveal top gradient from 75% progress
		if (heroHome) {
			const gradientU = Math.max(0, (u - 0.75) / 0.25);
			heroHome.style.setProperty("--_gradient-opacity", gradientU.toFixed(3));
		}

		if (elapsed < DELAY + DURATION + 500) {
			requestAnimationFrame(frame);
		} else {
			picStart.classList.add("is-reveal-done");
			canvas.remove();
		}
	}

	function start() {
		t0 = performance.now();
		generatePuffs();

		// Draw initial state immediately so there's no blank frame
		if (imgStart.naturalWidth) {
			ctx.clearRect(0, 0, W, H);
			drawCover(ctx, imgStart);
		}

		requestAnimationFrame(frame);
	}

	if (imgStart.complete && imgStart.naturalWidth > 0) {
		start();
	} else {
		imgStart.addEventListener("load", start, { once: true });
	}
}

document.addEventListener("DOMContentLoaded", heroHomeSmokeReveal);
